import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { TipoProductoId } from 'src/app/carga-masiva-productos/assets/columnas-producto.constants';
import { FuncionEspecificaService } from 'src/app/services/funcion-especifica.service';
import { GrupoNutricionalService } from 'src/app/services/grupo-nutricional.service';
import { IngredienteActivoService } from 'src/app/services/ingrediente-activo.service';
import { NombreComunService } from 'src/app/services/nombre-comun.service';
import {
    ProductoConsultaApi,
    ProductoConsultaService,
} from 'src/app/services/producto-consulta.service';
import { SubgrupoService } from 'src/app/services/subgrupo.service';
import { TipoProductoApiService } from 'src/app/services/tipo-producto-api.service';
import {
    ESTADOS_VALIDACION,
    FILTROS_INICIALES,
    FiltrosEdicionMasiva,
    FuncionEspecificaMaestro,
    EspecieMaestro,
    GrupoNutricionalMaestro,
    IngredienteActivoMaestro,
    OpcionMaestro,
} from './edita-masiva-productos.models';
import {
    EDITA_MASIVA_COLUMNS,
    FILTROS_CLASIFICACION_FERTILIZANTES,
    FILTROS_CLASIFICACION_NUTRICION_ANIMAL,
    FILTROS_CLASIFICACION_PLAGUICIDAS,
    FiltroEdicionMasivaDef,
    EDITA_MASIVA_COLUMNS_NUTRICION_ANIMAL,
} from './edita-masiva-productos.table-data';

export interface TabTipoProducto {
    id: number;
    nombre: string;
}

@Component({
    selector: 'app-edita-masiva-productos',
    templateUrl: './edita-masiva-productos.component.html',
    styleUrls: ['./edita-masiva-productos.component.css'],
})
export class EditaMasivaProductosComponent implements OnInit {
    public tiposProductoTab: TabTipoProducto[] = [];
    public activeTipoProductoId = Number(TipoProductoId.Plaguicida);

    public filters: Array<Record<string, unknown>> = [];
    public filtrosAplicados: FiltrosEdicionMasiva = { ...FILTROS_INICIALES };

    public columns = EDITA_MASIVA_COLUMNS;
    public data: Record<string, unknown>[] | null = null;
    public pagina = 1;
    public tamanoPagina = 10;
    public total = 0;

    private _subgruposCargados: OpcionMaestro[] = [];
    private _funcionesEspecificasCargadas: FuncionEspecificaMaestro[] = [];
    private _gruposNutricionalesCargados: GrupoNutricionalMaestro[] = [];
    private _ingredientesActivosCargados: IngredienteActivoMaestro[] = [];
    private _nombresComunesCargados: OpcionMaestro[] = [];
    private _productosConsultados: ProductoConsultaApi[] = [];
    private _ultimoFiltroConsulta: Record<string, string> = {};
    private _especiesCargadas: EspecieMaestro[] = [];
    private _etapasProductivasCargadas: OpcionMaestro[] = [];

    public constructor(
        private subgrupoService: SubgrupoService,
        private tipoProductoApi: TipoProductoApiService,
        private funcionesEspecificasApi: FuncionEspecificaService,
        private gruposNutricionalesApi: GrupoNutricionalService,
        private ingredientesActivosApi: IngredienteActivoService,
        private nombresComunesApi: NombreComunService,
        private productosApi: ProductoConsultaService
    ) {}

    public ngOnInit(): void {
        this.obtenerTiposProducto();
        this.cambiarTab(1);
    }

    public get funcionesEspecificasFiltradas(): FuncionEspecificaMaestro[] {
        const subgrupoId = this.valorFiltro('subgrupoId');
        if (!subgrupoId) {
            return this._funcionesEspecificasCargadas;
        }
        return this._funcionesEspecificasCargadas.filter(
            (f) => f.subgrupoId === Number(subgrupoId)
        );
    }

    public get gruposNutricionalesFiltrados(): GrupoNutricionalMaestro[] {
        const funcionEspecificaId = this.valorFiltro('funcionEspecificaId');
        if (!funcionEspecificaId) {
            return this._gruposNutricionalesCargados;
        }
        return this._gruposNutricionalesCargados.filter(
            (g) => g.funcionEspecificaId === Number(funcionEspecificaId)
        );
    }

    public get ingredientesActivosFiltrados(): IngredienteActivoMaestro[] {
        const grupoNutricionalId = this.valorFiltro('grupoNutricionalId');
        if (!grupoNutricionalId) {
            return this._ingredientesActivosCargados;
        }
        return this._ingredientesActivosCargados.filter(
            (i) => i.grupoNutricionalId === Number(grupoNutricionalId)
        );
    }

    public cambiarTab(tipoProductoId: number): void {
        this.activeTipoProductoId = tipoProductoId;
        this.limpiarFiltros(false);
        this.sincronizarCatalogosFiltro({});
        this.consultarProductos({
            filter: { tipoProductoId: String(tipoProductoId) },
        });
    }

    public limpiarFiltros(consultar = true): void {
        this.filters = this.crearFilters();
        if (consultar) {
            this.pagina = 1;
            this.consultarProductos({
                filter: this.construirFiltrosConsultaProductos(),
            });
        }
    }

    public onFiltersUpdate(payload: {
        filter: Record<string, string>;
        page: number;
        pageSize: number;
        cleanFilters?: boolean;
    }): void {
        this.pagina = payload.page;
        this.tamanoPagina = payload.pageSize;
        if (payload.cleanFilters) {
            this.filters = this.crearFilters();
            this.refrescarTabla();
        }
        if (this._ultimoFiltroConsulta !== payload.filter) {
            this._ultimoFiltroConsulta = payload.filter;
            this.sincronizarCatalogosFiltro(payload.filter);
            this.refrescarTabla();
        }
        this.consultarProductos(payload);
        this.refrescarTabla();
    }

    private construirFiltrosConsultaProductos(
        extra: Record<string, string> = {}
    ): Record<string, string> {
        this.filtrosAplicados = {
            nombreComercial: this.valorFiltro('nombreComercial').toUpperCase(),
            numeroRegistroIca: this.valorFiltro('numeroRegistroIca'),
            subgrupoId: this.valorNumericoFiltro('subgrupoId'),
            funcionEspecificaId: this.valorNumericoFiltro(
                'funcionEspecificaId'
            ),
            grupoNutricionalId: this.valorNumericoFiltro('grupoNutricionalId'),
            ingredienteActivoId: this.valorNumericoFiltro(
                'ingredienteActivoId'
            ),
            nombreComunId: this.valorNumericoFiltro('nombreComunId'),
            especieId: this.valorNumericoFiltro('especieId'),
            etapaProductiva: this.valorFiltro('etapaProductiva'),
            estadoValidacion:
                (this.valorFiltro(
                    'estadoValidacion'
                ) as FiltrosEdicionMasiva['estadoValidacion']) || '',
        };

        const f = this.filtrosAplicados;
        return {
            ...extra,
            ...(f.nombreComercial && { nombreComercial: f.nombreComercial }),
            ...(f.numeroRegistroIca && {
                numeroRegistroIca: f.numeroRegistroIca,
            }),
            ...(f.subgrupoId !== '' && { subgrupoId: String(f.subgrupoId) }),
            ...(f.funcionEspecificaId !== '' && {
                funcionEspecificaId: String(f.funcionEspecificaId),
            }),
            ...(f.grupoNutricionalId !== '' && {
                grupoNutricionalId: String(f.grupoNutricionalId),
            }),
            ...(f.ingredienteActivoId !== '' && {
                ingredienteActivoId: String(f.ingredienteActivoId),
            }),
            ...(f.nombreComunId !== '' && {
                nombreComunId: String(f.nombreComunId),
            }),
            ...(f.especieId !== '' && { especieId: String(f.especieId) }),
            ...(f.etapaProductiva && { etapaProductiva: f.etapaProductiva }),
            ...(f.estadoValidacion && {
                estadoValidacion: f.estadoValidacion,
            }),
        };
    }

    private crearFilters(): Array<Record<string, unknown>> {
        switch (this.activeTipoProductoId) {
            case Number(TipoProductoId.Plaguicida):
                this.columns = EDITA_MASIVA_COLUMNS;
                return (this.filters = this.materializarFiltros(
                    FILTROS_CLASIFICACION_PLAGUICIDAS
                ));
            case Number(TipoProductoId.Fertilizante):
                this.columns = EDITA_MASIVA_COLUMNS;
                return (this.filters = this.materializarFiltros(
                    FILTROS_CLASIFICACION_FERTILIZANTES
                ));
            case Number(TipoProductoId.Coadyuvante):
                this.columns = EDITA_MASIVA_COLUMNS;
                return (this.filters = this.materializarFiltros(
                    FILTROS_CLASIFICACION_FERTILIZANTES
                ));
            case Number(TipoProductoId.AcondicionadorEnmienda):
                this.columns = EDITA_MASIVA_COLUMNS;
                return (this.filters = this.materializarFiltros(
                    FILTROS_CLASIFICACION_FERTILIZANTES
                ));
            case Number(TipoProductoId.NutricionAnimal):
                this.columns = EDITA_MASIVA_COLUMNS_NUTRICION_ANIMAL;
                return (this.filters = this.materializarFiltros(
                    FILTROS_CLASIFICACION_NUTRICION_ANIMAL
                ));
            default:
                return (this.filters = []);
        }
    }

    private materializarFiltros(
        definiciones: FiltroEdicionMasivaDef[]
    ): Array<Record<string, unknown>> {
        const opciones: Record<string, unknown[]> = {
            especieId: this.toFilterOptions(this._especiesCargadas),
            etapaProductiva: this._etapasProductivasCargadas.map((item) => ({
                label: item.nombre,
                value: item.nombre,
            })),
            subgrupoId: this.toFilterOptions(this._subgruposCargados),
            funcionEspecificaId: this.toFilterOptions(
                this.funcionesEspecificasFiltradas
            ),
            grupoNutricionalId: this.toFilterOptions(
                this.gruposNutricionalesFiltrados
            ),
            ingredienteActivoId: this.toFilterOptions(
                this.ingredientesActivosFiltrados
            ),
            nombreComunId: this.toFilterOptions(this._nombresComunesCargados),
            estadoValidacion: ESTADOS_VALIDACION,
        };

        return definiciones.map((filtro) => ({
            ...filtro,
            value: '',
            ...((filtro.tipo === 'select' ||
                filtro.tipo === 'input-typeahead') && {
                options: opciones[filtro.campo] ?? [],
            }),
        }));
    }

    private toFilterOptions(
        lista: OpcionMaestro[]
    ): Array<{ label: string; value: string }> {
        return lista.map((item) => ({
            label: item.nombre,
            value: String(item.id),
        }));
    }

    private valorFiltro(campo: string): string {
        const filtro = this.filters.find((item) => item['campo'] === campo);
        const value = filtro?.['value'];
        return value === null || value === undefined
            ? ''
            : String(value).trim();
    }

    private valorNumericoFiltro(campo: string): number | '' {
        const valor = this.valorFiltro(campo);
        return valor === '' ? '' : Number(valor);
    }

    private tieneFiltro(campo: string): boolean {
        return this.filters.some((item) => item['campo'] === campo);
    }

    /** Se establecen las opciones del filtro */
    private setFiltro(
        campo: string,
        options: ReadonlyArray<{ label: string; value: string }>,
        value?: string
    ): void {
        const filtro = this.filters.find((item) => item['campo'] === campo);
        if (!filtro) return;
        filtro['options'] = options;
        if (value !== undefined) filtro['value'] = value;
    }

    /** Se sincronizan los catálogos de los filtros. */
    private sincronizarCatalogosFiltro(filter: Record<string, string>): void {
        this.obtenerSubgrupos();
        if (this.tieneFiltro('especieId')) {
            this.obtenerEspecies();
        }
        if (this.tieneFiltro('etapaProductiva')) {
            this.obtenerEtapasProductivas();
        }
        if (this.tieneFiltro('funcionEspecificaId')) {
            this.obtenerFuncionesEspecificas(filter.subgrupoId);
        }
        if (this.tieneFiltro('grupoNutricionalId')) {
            this.obtenerGruposNutricionales(filter.funcionEspecificaId);
        }
        if (this.tieneFiltro('ingredienteActivoId')) {
            this.obtenerIngredientesActivos(filter.grupoNutricionalId);
        }
        if (this.tieneFiltro('nombreComunId')) {
            this.obtenerNombresComunes();
        }
    }

    /****************************
     * Se obtienen las opciones de los filtros select.
     ****************************/

    /**
     * Nutrición animal queda al final; el resto conserva el orden del API.
     */
    private ordenarTiposProductoTab(
        tipos: TabTipoProducto[]
    ): TabTipoProducto[] {
        const idNutricionAnimal = Number(TipoProductoId.NutricionAnimal);
        return [...tipos].sort((a, b) => {
            const aUltimo = a.id === idNutricionAnimal ? 1 : 0;
            const bUltimo = b.id === idNutricionAnimal ? 1 : 0;
            return aUltimo - bUltimo;
        });
    }

    /**
     * Se obtienen los tipos de producto.
     */
    private obtenerTiposProducto(): void {
        this.tipoProductoApi.getTiposProducto().subscribe({
            next: (tipos) => {
                this.tiposProductoTab = this.ordenarTiposProductoTab(tipos);
            },
            error: () => {
                this.tiposProductoTab = [];
            },
        });
    }

    /**
     * Se obtienen los subgrupos.
     */
    private obtenerSubgrupos(): void {
        this.subgrupoService
            .getSubgrupos({
                tipoProductoId: this.activeTipoProductoId,
                estado: 'activo',
            })
            .subscribe({
                next: (subgrupos) => {
                    this._subgruposCargados = subgrupos;
                    this.setFiltro(
                        'subgrupoId',
                        this.toFilterOptions(subgrupos)
                    );
                    this.refrescarTabla();
                },
                error: () => {
                    this._subgruposCargados = [];
                },
            });
    }

    /** Catálogo de especies (nutrición animal). */
    private obtenerEspecies(): void {
        this.tipoProductoApi.getEspecies().subscribe({
            next: (especies) => {
                this._especiesCargadas = especies;
                this.setFiltro('especieId', this.toFilterOptions(especies));
                this.refrescarTabla();
            },
            error: () => {
                this._especiesCargadas = [];
            },
        });
    }

    /** Etapas productivas distintas registradas en alimentos balanceados. */
    private obtenerEtapasProductivas(): void {
        this.tipoProductoApi.getEtapasProductivas().subscribe({
            next: (etapas) => {
                this._etapasProductivasCargadas = etapas;
                this.setFiltro(
                    'etapaProductiva',
                    etapas.map((item) => ({
                        label: item.nombre,
                        value: item.nombre,
                    }))
                );
                this.refrescarTabla();
            },
            error: () => {
                this._etapasProductivasCargadas = [];
            },
        });
    }

    /**
     * Se obtienen las funciones específicas.
     */
    private obtenerFuncionesEspecificas(
        subgrupoId?: string | number | null
    ): void {
        this.funcionesEspecificasApi
            .getFuncionesEspecificas({
                tipoProductoId: this.activeTipoProductoId,
                estado: 'activo',
                ...(subgrupoId !== undefined &&
                    subgrupoId !== null &&
                    String(subgrupoId).trim() !== '' && {
                        subgrupoId: Number(subgrupoId),
                    }),
            })
            .subscribe({
                next: (funciones) => {
                    this._funcionesEspecificasCargadas = funciones;
                    this.setFiltro(
                        'funcionEspecificaId',
                        this.toFilterOptions(funciones)
                    );
                    this.refrescarTabla();
                },
                error: () => {
                    this._funcionesEspecificasCargadas = [];
                },
            });
    }

    /**
     * Se obtienen los grupos nutricionales.
     */
    private obtenerGruposNutricionales(
        funcionEspecificaId?: string | number | null
    ): void {
        this.gruposNutricionalesApi
            .getGruposNutricionales({
                tipoProductoId: this.activeTipoProductoId,
                estado: 'activo',
                ...(funcionEspecificaId !== undefined &&
                    funcionEspecificaId !== null &&
                    String(funcionEspecificaId).trim() !== '' && {
                        funcionEspecificaId: Number(funcionEspecificaId),
                    }),
            })
            .subscribe({
                next: (grupos) => {
                    this._gruposNutricionalesCargados = grupos;
                    this.setFiltro(
                        'grupoNutricionalId',
                        this.toFilterOptions(grupos)
                    );
                    this.refrescarTabla();
                },
                error: () => {
                    this._gruposNutricionalesCargados = [];
                },
            });
    }

    /**
     * Se obtienen los ingredientes activos / funcion química.
     */
    private obtenerIngredientesActivos(
        grupoNutricionalId?: string | number | null
    ): void {
        this.ingredientesActivosApi
            .getIngredientesActivos({
                tipoProductoId: this.activeTipoProductoId,
                estado: 'activo',
                ...(grupoNutricionalId !== undefined &&
                    grupoNutricionalId !== null &&
                    String(grupoNutricionalId).trim() !== '' && {
                        grupoNutricionalId: Number(grupoNutricionalId),
                    }),
            })
            .subscribe({
                next: (ingredientes) => {
                    this._ingredientesActivosCargados = ingredientes.map(
                        (item) => ({
                            id: item.id,
                            nombre: item.nombre,
                            grupoNutricionalId: item.funcionQuimicaId,
                        })
                    );
                    this.setFiltro(
                        'ingredienteActivoId',
                        this.toFilterOptions(ingredientes)
                    );
                    this.refrescarTabla();
                },
                error: () => {
                    this._ingredientesActivosCargados = [];
                },
            });
        this.refrescarTabla();
    }

    /**
     * Se obtienen los nombres comunes.
     */
    private obtenerNombresComunes(): void {
        this.nombresComunesApi
            .getNombresComunes({ estado: 'activo', tipoProductoId: this.activeTipoProductoId })
            .subscribe({
                next: (nombres) => {
                    this._nombresComunesCargados = nombres;
                    this.setFiltro(
                        'nombreComunId',
                        this.toFilterOptions(nombres)
                    );
                    this.refrescarTabla();
                },
                error: () => {
                    this._nombresComunesCargados = [];
                },
            });
    }

    /*******************************************
     * Se consultan y mapean los productos.
     */

    public consultarProductos(payload: {
        filter?: Record<string, string>;
        page?: number;
        pageSize?: number;
    }): void {
        const filter = payload.filter ?? {};
        this.productosApi
            .getProductos({
                page: payload.page ?? 1,
                pageSize: payload.pageSize ?? 10,
                filter: {
                    ...filter,
                    tipoProductoId: String(
                        filter.tipoProductoId ?? this.activeTipoProductoId
                    ),
                },
            })
            .subscribe({
                next: (response) => {
                    this._productosConsultados = response.data;
                    this.total = response.total;
                    this.pagina = response.page;
                    this.tamanoPagina = response.pageSize;
                    this.refrescarTabla();
                },
                error: () => {
                    Swal.fire(
                        '',
                        'No se pudieron consultar los productos. Intente nuevamente.',
                        'error'
                    );
                },
            });
    }

    private refrescarTabla(): void {
        this.data = this._productosConsultados.map((producto) =>
            this.toTableRow(producto)
        );
    }

    private alimentoNutricionAnimal(
        producto: ProductoConsultaApi
    ):
        | NonNullable<
              ProductoConsultaApi['alimentoBalanceadoParaAnimales']
          >[number]
        | undefined {
        const items = producto.alimentoBalanceadoParaAnimales;
        if (!items?.length) {
            return undefined;
        }
        return items[0];
    }

    private toTableRow(producto: ProductoConsultaApi): Record<string, unknown> {
        const alimento = this.alimentoNutricionAnimal(producto);
        return {
            id: producto.id,
            producto: [
                `<strong>Nombre:</strong> ${this.escapeHtml(producto.nombreComercial ?? '')}`,
                `<strong>Reg ICA:</strong> ${this.escapeHtml(producto.numeroRegistroIca ?? '')}`,
                `<strong>Casa Prod:</strong> ${this.escapeHtml(producto.casaProductora ?? '')}`,
                `<strong>Origen:</strong> ${this.escapeHtml(String(producto.origenDelProducto ?? producto.OrigenDelProducto ?? ''))}`,
            ].join('<br>'),
            presentaciones: (producto.presentaciones ?? [])
                .map((p) =>
                    this.escapeHtml(
                        `${p.empaqueUnidadMedida?.empaque?.nombre ?? ''} de ${p.cantidad ?? ''} ${p.empaqueUnidadMedida?.unidadMedida?.abreviacion ?? ''}`
                    )
                )
                .join('<br>'),
            especie:
                alimento?.especie?.nombre ??
                this._especiesCargadas.find(
                    (item) => item.id === alimento?.especieId
                )?.nombre ??
                '',
            etapaProductiva:
                alimento?.etapaProductivaCatalogo?.nombre ??
                alimento?.etapaProductiva ??
                '',
            subgrupo:
                this._subgruposCargados.find(
                    (item) => item.id === producto.subgrupoId
                )?.nombre ?? '',
            funcionEspecifica:
                this._funcionesEspecificasCargadas.find(
                    (item) => item.id === producto.funcionEspecificaId
                )?.nombre ?? '',
            grupoNutricional:
                this._gruposNutricionalesCargados.find(
                    (item) => item.id === producto.funcionQuimicaId
                )?.nombre ?? '',
            ingredienteActivo:
                this._ingredientesActivosCargados.find(
                    (item) => item.id === producto.composicionId
                )?.nombre ?? '',
            nombreComun:
                this._nombresComunesCargados.find(
                    (item) => item.id === producto.nombreComunId
                )?.nombre ?? '',
            estadoValidacionHtml: this.formatEstadoValidacionBadge(
                producto.estadoValidacion ?? ''
            ),
            observaciones: '',
        };
    }

    private formatEstadoValidacionBadge(estado: string): string {
        const texto = estado.trim();
        if (!texto) {
            return '';
        }
        const esc = this.escapeHtml(texto);
        const badgeClass = this.estadoValidacionBadgeClass(texto);
        const icon = this.estadoValidacionBadgeIcon(texto);
        return `<span class="badge ${badgeClass}">${icon}${esc}</span>`;
    }

    private estadoValidacionBadgeIcon(estado: string): string {
        switch (estado) {
            case 'Pendiente':
                return '<i class="fas fa-hourglass-half me-1"></i>';
            case 'Aprobado':
                return '<i class="fas fa-check me-1"></i>';
            case 'En validación':
            case 'Ajustes denegados':
                return '<i class="fas fa-exclamation-triangle me-1"></i>';
            default:
                return '';
        }
    }

    private estadoValidacionBadgeClass(estado: string): string {
        switch (estado) {
            case 'Pendiente':
                return 'badge-info';
            case 'Aprobado':
                return 'badge-success';
            case 'En validación':
                return 'badge-warning';
            case 'Ajustes denegados':
                return 'badge-danger';
            default:
                return '';
        }
    }

    private escapeHtml(value: string): string {
        return value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }
}
